import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/icons/actions/ico-btn-edit.svg';
import _imports_1 from '@/assets/icons/actions/ico-ico-delete.svg';
import _imports_2 from '@/assets/icons/sluzba-check.svg';
const _hoisted_1 = { class: "detail-page" };
const _hoisted_2 = { class: "detail-page__sticky-header__left d-flex align-items-center" };
const _hoisted_3 = { class: "detail-page__sticky-header__name" };
const _hoisted_4 = { class: "detail-page__sticky-header__right d-flex align-items-center justify-content-between" };
const _hoisted_5 = { class: "d-flex align-items-end detail-page__tabs__wrapper" };
const _hoisted_6 = { class: "d-flex align-items-center justify-content-end detail-page__sticky-header__buttons" };
const _hoisted_7 = {
    key: 1,
    id: "detail-header",
    class: "layout__content__header layout__content__header--white"
};
const _hoisted_8 = { class: "d-flex justify-content-between" };
const _hoisted_9 = { class: "mb-0 layout__content__header__title" };
const _hoisted_10 = { class: "layout__content__header__buttons d-none d-md-flex justify-content-end align-items-end" };
const _hoisted_11 = { class: "detail-page__info d-flex align-items-center font-weight-light" };
const _hoisted_12 = {
    key: 0,
    class: "detail-page__info__item"
};
const _hoisted_13 = {
    key: 0,
    class: "detail-page__boxes d-flex flex-column flex-md-row"
};
const _hoisted_14 = { class: "detail-page__boxes__item" };
const _hoisted_15 = { class: "label font-weight-light" };
const _hoisted_16 = { class: "detail-page__boxes__value d-flex align-items-center" };
const _hoisted_17 = {
    key: 0,
    class: "font-weight-bolder"
};
const _hoisted_18 = { key: 1 };
const _hoisted_19 = { class: "detail-page__boxes__item" };
const _hoisted_20 = { class: "label font-weight-light" };
const _hoisted_21 = { class: "detail-page__boxes__value d-flex align-items-center" };
const _hoisted_22 = {
    key: 0,
    class: "detail-page__boxes__item__textDashed"
};
const _hoisted_23 = {
    key: 1,
    class: "detail-page__tags d-flex flex-column flex-sm-row font-weight-light align-items-start"
};
const _hoisted_24 = {
    key: 0,
    class: "d-flex flex-column flex-md-row detail-page__tags__tagRow"
};
const _hoisted_25 = { class: "ml-md-2 mr-md-4 d-flex align-items-center flex-wrap" };
const _hoisted_26 = {
    key: 1,
    class: "d-flex flex-column flex-md-row mt-3 mt-sm-0 detail-page__tags__paramsRow"
};
const _hoisted_27 = { class: "layout__content__content pt-0 px-0" };
const _hoisted_28 = {
    id: "tabs",
    class: "detail-page__tabs"
};
const _hoisted_29 = { class: "detail-page__tabs__header d-flex" };
const _hoisted_30 = { class: "d-flex align-items-end detail-page__tabs__wrapper" };
const _hoisted_31 = { class: "detail-page__tabs__content overflow-visible" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = {
    key: 1,
    class: "messages"
};
const _hoisted_34 = { key: 2 };
import DeviceStatusIcon from "@/components/devices/partials/DeviceStatusIcon.vue";
import { computed, onMounted, ref } from "vue";
import TagBubbles from "@/components/devices/tagBubbles.vue";
import { useStore } from "vuex";
import Back from "@/components/back.vue";
import { useRoute, useRouter } from "vue-router";
import { client } from "@/main";
import { getVisibleAttributes, getVisibleTags } from "@/plugins/getVisible";
import DataFlowOverview from "@/components/devices/partials/DataFlowOverview.vue";
import DetailTab from "@/components/devices/udp/tabs/detailTab.vue";
import MessagesTab from "@/components/devices/udp/tabs/messagesTab.vue";
import UdpDeviceFormModal from "@/components/devices/udp/UdpDeviceFormModal.vue";
import Delete from "@/components/confirmations/delete.vue";
import { useProjectStore } from "@/store/modules/project";
import { useCustomerStore } from "@/store/modules/customer";
import { useAuthStore } from "@/store/modules/auth";
import UserAttributesBubbles from "@/components/devices/userAttributesBubbles.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'udpDevice',
    setup(__props) {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();
        const projectStore = useProjectStore();
        const customerStore = useCustomerStore();
        const authStore = useAuthStore();
        const project = computed(() => projectStore.selectedProject);
        const customer = computed(() => customerStore.selectedCustomer);
        const apiUser = computed(() => authStore.apiUser);
        const device = ref(null);
        const service = ref(null);
        const deviceGroupsWithEndpoints = ref([]);
        const isHeaderFixed = ref(false);
        const selectedTab = ref(1);
        const transformationFunction = ref(null);
        const deviceGroups = ref([]);
        const isFormModalOpen = ref(false);
        const visibleTags = computed(() => getVisibleTags(device.value?.tags, apiUser.value?.isIotAdmin) ?? []);
        const visibleAttributes = computed(() => getVisibleAttributes(device.value?.attributes, apiUser.value?.isIotAdmin) ?? []);
        onMounted(() => {
            loadDevice();
            const tabsElement = document.getElementById("tabs");
            window.document.onscroll = () => {
                if (tabsElement) {
                    isHeaderFixed.value = window.scrollY > tabsElement.offsetTop + 250;
                }
            };
        });
        async function loadDevice() {
            const { data: result } = await client.path("/udp/devices/{id}").method("get").create()({ id: route.params.id });
            device.value = result.data ?? null;
            loadService();
            loadGroupsWithEndpoints();
            loadDeviceGroups();
            if (route.params.projectId != device.value?.projectId) {
                router.push({ name: "udp" });
            }
            if (device.value?.transformationId) {
                loadTransformation();
            }
        }
        async function loadService() {
            const { data: result } = await client.path("/services/{id}").method("get").create()({ id: device.value.serviceId });
            service.value = result.data ?? null;
        }
        async function loadGroupsWithEndpoints() {
            deviceGroupsWithEndpoints.value = [];
            for (const group of device.value.deviceGroups ?? []) {
                const { data: result } = await client.path("/device-groups/{id}/endpoints").method("get").create()({
                    id: group.deviceGroupId
                });
                deviceGroupsWithEndpoints.value.push({ group, endpoints: result.data });
            }
        }
        const isDeleteModalOpen = ref(false);
        function toggleDeleteModal() {
            isDeleteModalOpen.value = !isDeleteModalOpen.value;
        }
        async function deleteDevice() {
            for (const group of device.value.deviceGroups) {
                await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("delete").create()({
                    deviceId: device.value.deviceId,
                    id: group.deviceGroupId,
                    protocol: "udp"
                });
            }
            await client.path("/udp/devices/{id}").method("delete").create()({ id: device.value.deviceId });
            router.push({ name: "udpDevices" });
        }
        async function loadTransformation() {
            const { data } = await client.path("/transformations/{transformationId}").method("get").create()({
                transformationId: device.value.transformationId
            });
            transformationFunction.value = data.data;
        }
        async function loadDeviceGroups() {
            const { data } = await client.path("/device-groups").method("get").create()({
                "deviceGroupId[in]": device.value.deviceGroups.map((g) => g.deviceGroupId).toString()
            });
            deviceGroups.value = data.data;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    (device.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([{ visible: isHeaderFixed.value }, "detail-page__sticky-header d-flex align-items-center"])
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("strong", _hoisted_3, _toDisplayString(_ctx.$filters.strLimit(device.value.name, 8)), 1),
                                _createVNode(DeviceStatusIcon, { device: device.value }, null, 8, ["device"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("pred")) + " " + _toDisplayString(_ctx.$filters.beforeTime(device.value.lastMessageIn, "short")), 1)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value === 1 }, "detail-page__tabs__tab"]),
                                        onClick: _cache[0] || (_cache[0] = ($event) => (selectedTab.value = 1))
                                    }, _toDisplayString(_ctx.$t("routovaciSkupiny")), 3),
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value === 2 }, "detail-page__tabs__tab"]),
                                        onClick: _cache[1] || (_cache[1] = ($event) => (selectedTab.value = 2))
                                    }, _toDisplayString(_ctx.$t("zpravy")), 3),
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value === 3 }, "detail-page__tabs__tab"]),
                                        onClick: _cache[2] || (_cache[2] = ($event) => (selectedTab.value = 3))
                                    }, _toDisplayString(_ctx.$t("vseOZarizeni")), 3)
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary d-flex align-items-center justify-content-center",
                                        onClick: _cache[3] || (_cache[3] = ($event) => (isFormModalOpen.value = true))
                                    }, [
                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "atom-icon" }, [
                                            _createElementVNode("img", { src: _imports_0 })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("upravit")), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0",
                                        onClick: _cache[4] || (_cache[4] = ($event) => (toggleDeleteModal([device.value])))
                                    }, _cache[15] || (_cache[15] = [
                                        _createElementVNode("div", { class: "atom-icon m-0" }, [
                                            _createElementVNode("img", { src: _imports_1 })
                                        ], -1)
                                    ]))
                                ])
                            ])
                        ], 2))
                        : _createCommentVNode("", true),
                    (device.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(Back, {
                                route: '/devices/udp/' + customer.value.customerId + '/' + project.value.projectId,
                                text: 'naSeznamZarizeni'
                            }, null, 8, ["route"]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("h1", _hoisted_9, _toDisplayString(device.value.name), 1),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary d-flex align-items-center justify-content-center",
                                        onClick: _cache[5] || (_cache[5] = ($event) => (isFormModalOpen.value = true))
                                    }, [
                                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "atom-icon" }, [
                                            _createElementVNode("img", { src: _imports_0 })
                                        ], -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t("upravit")), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0",
                                        onClick: _cache[6] || (_cache[6] = ($event) => (toggleDeleteModal()))
                                    }, _cache[17] || (_cache[17] = [
                                        _createElementVNode("div", { class: "atom-icon m-0" }, [
                                            _createElementVNode("img", { src: _imports_1 })
                                        ], -1)
                                    ]))
                                ])
                            ]),
                            _createVNode(DeviceStatusIcon, {
                                device: device.value,
                                class: "mb-3 mb-md-5",
                                "show-description": ""
                            }, null, 8, ["device"]),
                            _createElementVNode("div", _hoisted_11, [
                                (device.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(device.value.deviceId), 1))
                                    : _createCommentVNode("", true),
                                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "detail-page__info__item" }, "UDP", -1))
                            ]),
                            (device.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("Poslední zpráva")), 1),
                                        _createElementVNode("div", _hoisted_16, [
                                            (device.value.lastMessageIn != null)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("pred")) + " " + _toDisplayString(_ctx.$filters.beforeTime(device.value.lastMessageIn, "short")), 1)
                                                ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_18, "N/A"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("sluzba"))), 1),
                                        _createElementVNode("div", _hoisted_21, [
                                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "atom-icon justify-content-start" }, [
                                                _createElementVNode("img", { src: _imports_2 })
                                            ], -1)),
                                            (service.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(service.value.custServiceName), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (device.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                    (visibleTags.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                            _createTextVNode(_toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("tagy"))) + " ", 1),
                                            _createElementVNode("div", _hoisted_25, [
                                                _createVNode(TagBubbles, {
                                                    "tag-list": device.value.tags
                                                }, null, 8, ["tag-list"])
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    (Object.keys(visibleAttributes.value).length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                            _createTextVNode(_toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("parametry"))) + " ", 1),
                                            _createVNode(UserAttributesBubbles, {
                                                attributes: device.value.attributes
                                            }, null, 8, ["attributes"])
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value === 1 }, "detail-page__tabs__tab"]),
                                        onClick: _cache[7] || (_cache[7] = ($event) => (selectedTab.value = 1))
                                    }, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("routovaciSkupiny"))), 3),
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value === 2 }, "detail-page__tabs__tab position-relative"]),
                                        onClick: _cache[8] || (_cache[8] = ($event) => (selectedTab.value = 2))
                                    }, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("zpravy"))), 3),
                                    _createElementVNode("div", {
                                        class: _normalizeClass([{ active: selectedTab.value == 3 }, "detail-page__tabs__tab position-relative"]),
                                        onClick: _cache[9] || (_cache[9] = ($event) => (selectedTab.value = 3))
                                    }, _toDisplayString(_ctx.$filters.firstUpper(_ctx.$t("vseOZarizeni"))), 3)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                (selectedTab.value === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        (device.value)
                                            ? (_openBlock(), _createBlock(DataFlowOverview, {
                                                key: 0,
                                                device: device.value,
                                                groups: deviceGroups.value,
                                                "groups-endpoints": deviceGroupsWithEndpoints.value ?? [],
                                                "last-message-in": device.value.lastMessageIn,
                                                "transform-key": Math.random().toString(),
                                                "device-type": "udp",
                                                onEditDevice: _cache[10] || (_cache[10] = ($event) => (isFormModalOpen.value = true)),
                                                onReloadDevice: loadDevice
                                            }, null, 8, ["device", "groups", "groups-endpoints", "last-message-in", "transform-key"]))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                (selectedTab.value === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createVNode(MessagesTab, { device: device.value }, null, 8, ["device"])
                                    ]))
                                    : _createCommentVNode("", true),
                                (selectedTab.value === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createVNode(DetailTab, {
                                            device: device.value,
                                            service: service.value,
                                            "transformation-function": transformationFunction.value
                                        }, null, 8, ["device", "service", "transformation-function"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ]),
                (device.value)
                    ? (_openBlock(), _createBlock(UdpDeviceFormModal, {
                        key: 0,
                        "edited-device": device.value,
                        "is-opened": isFormModalOpen.value,
                        onClose: _cache[11] || (_cache[11] = ($event) => (isFormModalOpen.value = false)),
                        onChange: loadDevice
                    }, null, 8, ["edited-device", "is-opened"]))
                    : _createCommentVNode("", true),
                _createVNode(Delete, {
                    centered: "",
                    items: [device.value],
                    opened: isDeleteModalOpen.value,
                    text: device.value?.name,
                    onClose: _cache[12] || (_cache[12] = ($event) => (toggleDeleteModal())),
                    onYes: _cache[13] || (_cache[13] =
                        () => {
                            deleteDevice();
                            toggleDeleteModal();
                        })
                }, null, 8, ["items", "opened", "text"])
            ], 64));
        };
    }
});
